import { render, staticRenderFns } from "./FundRingChart.vue?vue&type=template&id=00f0fd5c&scoped=true&"
import script from "./FundRingChart.vue?vue&type=script&lang=js&"
export * from "./FundRingChart.vue?vue&type=script&lang=js&"
import style0 from "./FundRingChart.vue?vue&type=style&index=0&id=00f0fd5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f0fd5c",
  null
  
)

export default component.exports